export const SHARECODE = '<a href=”https://doda.jp/”>転職サイト「doda」</a>';
